import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "localization-page" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header-buttons" }
const _hoisted_4 = {
  href: "/GolfLocalization.csv",
  download: "GolfLocalization.csv",
  class: "download-link"
}

import { ref, onMounted } from 'vue'
import dayjs from 'dayjs'
import { ElMessage } from 'element-plus'
import {
  getGolfLocalizationFiles,
  uploadGolfLocalizationFile,
  activateGolfLocalizationFile,
  deleteGolfLocalizationFile,
  GolfLocalizationFile,
} from '@/api/golf-localization'
import { useGolfI18nStore } from '@/store/golf-i18n'
import { extractErrorMessage } from '@/helpers/error-parsers'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const files = ref<GolfLocalizationFile[]>([])
const loading = ref(false)
const golfI18nStore = useGolfI18nStore()

const fetchFiles = async () => {
  loading.value = true
  try {
    const response = await getGolfLocalizationFiles()
    files.value = (response as any).data
  } catch (error) {
    console.error(error)
    ElMessage.error({
      message: extractErrorMessage(
        error,
        'Failed to fetch golf localization files'
      ),
      duration: 6000,
      showClose: true,
    })
  } finally {
    loading.value = false
  }
}

const handleUpload = async (options: any) => {
  try {
    await uploadGolfLocalizationFile(options.file)
    ElMessage.success('Golf localization file uploaded successfully')
    fetchFiles()
  } catch (error) {
    console.error(error)
    ElMessage.error({
      message: extractErrorMessage(error, 'Failed to upload file'),
      duration: 6000,
      showClose: true,
    })
  }
}

const handleActivate = async (file: GolfLocalizationFile) => {
  try {
    await activateGolfLocalizationFile(file.id)
    ElMessage.success('Golf localization file activated successfully')
    await fetchFiles()
    await golfI18nStore.fetchTranslations()
  } catch (error) {
    console.error(error)
    ElMessage.error({
      message: extractErrorMessage(error, 'Failed to activate file'),
      duration: 6000,
      showClose: true,
    })
  }
}

const handleDelete = async (file: GolfLocalizationFile) => {
  try {
    await deleteGolfLocalizationFile(file.id)
    ElMessage.success('File deleted successfully')
    fetchFiles()
  } catch (error) {
    console.error(error)
    ElMessage.error({
      message: extractErrorMessage(error, 'Failed to delete file'),
      duration: 6000,
      showClose: true,
    })
  }
}

const formatDate = (date: string) => {
  return dayjs(date).format('YYYY-MM-DD HH:mm')
}

onMounted(() => {
  fetchFiles()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Localization Golf module", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, [
          _createVNode(_component_el_button, {
            type: "info",
            plain: ""
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("Download Template CSV")
            ])),
            _: 1,
            __: [0]
          })
        ]),
        _createVNode(_component_el_upload, {
          class: "upload-demo",
          action: "#",
          "http-request": handleUpload,
          "show-file-list": false,
          accept: ".csv"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, { type: "primary" }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("Upload CSV")
              ])),
              _: 1,
              __: [1]
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_el_card, { class: "tutorial-card" }, {
      header: _withCtx(() => _cache[3] || (_cache[3] = [
        _createElementVNode("div", { class: "card-header" }, [
          _createElementVNode("span", null, "How to update Golf module localization")
        ], -1)
      ])),
      default: _withCtx(() => [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "tutorial-content" }, [
          _createElementVNode("p", null, " 1. Open the Google Sheet with Golf module translations or download the template above. "),
          _createElementVNode("p", null, "2. Ensure columns are structured as: Key,en,az,ru."),
          _createElementVNode("p", null, "3. Go to File > Download > Comma Separated Values (.csv)."),
          _createElementVNode("p", null, " 4. Upload the downloaded file using the Upload CSV button, then click Activate. ")
        ], -1))
      ]),
      _: 1,
      __: [4]
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: files.value,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "id",
          label: "ID",
          width: "300"
        }),
        _createVNode(_component_el_table_column, {
          prop: "original_name",
          label: "Filename"
        }),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: "Created At"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(formatDate(scope.row.created_at)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Status",
          width: "120"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              type: scope.row.is_active ? 'success' : 'info'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.is_active ? 'Active' : 'Inactive'), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Actions",
          width: "200"
        }, {
          default: _withCtx((scope) => [
            (!scope.row.is_active)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  size: "small",
                  type: "success",
                  onClick: ($event: any) => (handleActivate(scope.row))
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode(" Activate ")
                  ])),
                  _: 2,
                  __: [5]
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (files.value.length > 1)
              ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                  key: 1,
                  title: "Are you sure to delete this file?",
                  onConfirm: ($event: any) => (handleDelete(scope.row))
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "danger"
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode("Delete")
                      ])),
                      _: 1,
                      __: [6]
                    })
                  ]),
                  _: 2
                }, 1032, ["onConfirm"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ])
  ]))
}
}

})